// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3lS60","inner":"Form_inner__tPkBT","range":"Form_range__2ProN","name":"Form_name__1IR3p","actions":"Form_actions__3H1Ab"};